/**
 * Reports API Slice
 *
 * RTK Query endpoints for user-side content reporting.
 */

import { api } from '../api';

// ============================================
// Types
// ============================================

export type ReportTargetType = 'profile' | 'session' | 'pitch' | 'expert';

export interface CreateReportRequest {
  targetType: ReportTargetType;
  targetId: string;
  reason: string;
}

export interface ReportDto {
  id: string;
  reporterUserId: string | null;
  targetType: ReportTargetType;
  targetId: string;
  reason: string;
  createdAt: string;
  status: 'open' | 'resolved' | 'dismissed';
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

// ============================================
// API Slice
// ============================================

export const reportsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createReport: builder.mutation<ReportDto, CreateReportRequest>({
      query: (body) => ({
        url: '/reports',
        method: 'POST',
        body,
      }),
      transformResponse: (response: ApiResponse<ReportDto>) => response.data,
    }),
  }),
  overrideExisting: false,
});

export const { useCreateReportMutation } = reportsApi;
